/**
 * @author Madhu.Sudhan
 * @Date: 2023-05-10 13:05:06
 * @Last Modified by: madhusudhan
 * @Last Modified time: 2023-05-10 17:50:20
 */

import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Form, Breadcrumb, Card, Divider, Input, Select, DatePicker, Button, Checkbox } from 'antd';

import { AppWrappperHOC } from '../Root/HOC';
import { constants, utils, validationRules } from '../../devUtils';
import Container from '../../components/Container';
import { ZaggleCard } from '../NetworkCards/StyledNetworkCard';
import { YblMinKycPropTypes, YblMinKycmapDispatchToProps, YblMinKycmapStateToProps } from './YblMinKycDatahandler';
import { StyledYblMinKyc } from './StyledYblMinKyc';
import Modal from '../../components/Modal';
import { aadharConsentText, AADHAR } from './constants';
import { DATE_DEAL_FORMAT } from '../../devUtils/constants';

const { Option } = Select;

class YblMinKyc extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalType: '',
      aadharConsent: false,
    };
    this.statelesskeys = {
      defaultPayload: {},
      setActiveTabKey: '1',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    const {
      onKycStaticData,
    } = this.props;
    onKycStaticData();
  }

  componentWillReceiveProps(nextProps) {
    const {
      YblMinKycSuccess: _YblMinKycSuccess,
    } = this.props;
    const {
      YblMinKycSuccess, YblMinKycSuccess: { status },
    } = nextProps;
    if (!utils.isEqual(YblMinKycSuccess, _YblMinKycSuccess) && status) {
      this.setState({ modalType: 'DOWNLOAD_SUCCESS' });
    }
  }

  handleModal(type) {
    this.setState({
      modalType: typeof (type) === 'string' ? type : '',
    });
  }

  handleSubmit(evt) {
    evt.preventDefault();
    const {
      form: {
        validateFields,
      },
      onYesBankMinKyc,
      location: {
        dataFromRedirection: {
          phone = '',
          token = '',
        } = {},
      } = {},
    } = this.props;
    validateFields((err, values) => {
      if (!err) {
        const {
          name = '',
          aadhar_number = '',
          dob = '',
          gender = '',
          address = '',
          pin_code = '',
          profession = '',
          education_qualification = '',
          annual_income = '',
          source_of_funds = '',
          self_employed_profession = '',
          nature_of_business = '',
        } = values;
        const payload = {
          mobile: phone,
          full_name: name,
          kyc_number: aadhar_number,
          kyc_type: AADHAR,
          dob: dob.format(DATE_DEAL_FORMAT),
          gender,
          address,
          pin_code,
          token,
          profession,
          education_qualification,
          annual_income,
          source_of_funds,
          self_employed_profession,
          nature_of_business,
        };
        onYesBankMinKyc(payload);
      }
    });
  }

  closeModal(actionType) {
    if (actionType && actionType === 'DOWNLOAD_SUCCESS') {
      this.setState({ modalType: '' });
    }
    this.validators = utils.resetValidators(this.validators);
  }

  renderYblMinKycPage() {
    const {
      form:
      {
        getFieldDecorator,
        getFieldValue,
      } = {},
      KycStaticData: {
        response: {
          annual_income_options = [],
          education_options = [],
          nature_of_business_options = [],
          profession_options = [],
          self_employed_profession_options = [],
          source_of_fund_options = [],
        } = {},
      } = {},
      isLoadingStatus,
    } = this.props;
    const {
      aadharConsent,
    } = this.state;
    return (
      <Row align="middle" type="flex" gutter={20}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <strong className="font-18">MIN KYC</strong>
          <Divider />
          <StyledYblMinKyc>
            <Form
              onSubmit={this.handleSubmit}
              layout="vertical"
            >
              <Row align="middle" type="flex" justify="start" gutter={20}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Row align="middle" type="flex" justify="start" gutter={30}>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Form.Item label="KYC Document">
                        {getFieldDecorator('doc_type', {
                          initialValue: 'Aadhar Card',
                          rules: [validationRules.mandatory],
                        })(
                          <Input
                            className="custom-input"
                            disabled
                          >
                          </Input>
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Form.Item label="Aadhar Number">
                        {getFieldDecorator('aadhar_number', {
                          initialValue: '',
                          rules: [validationRules.validAadhaarNumber],
                        })(
                          <Input
                            placeholder="Enter Document Number"
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Form.Item label="Name as per Aadhar">
                        {getFieldDecorator('name', {
                          initialValue: '',
                          rules: [validationRules.mandatory],
                        })(
                          <Input
                            placeholder="Enter Name"
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Form.Item label="Gender">
                        {getFieldDecorator('gender', {
                          rules: [validationRules.mandatory],
                        })(
                          <Select placeholder="Select Gender">
                            <Option value="M">Male</Option>
                            <Option value="F">Female</Option>
                            <Option value="T">Others</Option>
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row align="middle" type="flex" justify="start" gutter={30}>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Form.Item label="DOB as per Aadhar">
                        {getFieldDecorator('dob', {
                          rules: [validationRules.mandatory],
                        })(
                          <DatePicker
                            className="custom-datepicker"
                            format="DD-MM-YYYY"
                            placeholder="DD-MM-YYYY"
                            disabledDate={utils.disableDate}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Form.Item label="Address as per Aadhar">
                        {getFieldDecorator('address', {
                          initialValue: '',
                          rules: [validationRules.mandatory],
                        })(
                          <Input.TextArea
                            placeholder="Enter Address"
                            rows={2}
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Form.Item label="Pin Code as per Aadhar">
                        {getFieldDecorator('pin_code', {
                          initialValue: '',
                          rules: [validationRules.validIndianPincode],
                        })(
                          <Input
                            placeholder="Enter Pincode"
                          />
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Form.Item label="Profession">
                        {getFieldDecorator('profession', {
                          rules: [validationRules.mandatory],
                        })(
                          <Select placeholder="Select Profession">
                            {profession_options && profession_options.length && profession_options.map(({ name = '', value = '' }) => (
                              <Option key={value} value={value}>{name}</Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row align="middle" type="flex" justify="start" gutter={30}>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Form.Item label="Qualification">
                        {getFieldDecorator('education_qualification', {
                          rules: [validationRules.mandatory],
                        })(
                          <Select placeholder="Select Education Qualification">
                            {education_options && education_options.length && education_options.map(({ name = '', value = '' }) => (
                              <Option key={value} value={value}>{name}</Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Form.Item label="Annual Income">
                        {getFieldDecorator('annual_income', {
                          rules: [validationRules.mandatory],
                        })(
                          <Select placeholder="Select Annual Income">
                            {annual_income_options && annual_income_options.length && annual_income_options.map(({ name = '', value = '' }) => (
                              <Option key={value} value={value}>{name}</Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                      <Form.Item label="Source of Funds">
                        {getFieldDecorator('source_of_funds', {
                          rules: [validationRules.mandatory],
                        })(
                          <Select placeholder="Select Source of Funds">
                            {source_of_fund_options && source_of_fund_options.length && source_of_fund_options.map(({ name = '', value = '' }) => (
                              <Option key={value} value={value}>{name}</Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                    {getFieldValue('profession') === 'SELF-EMPLOYED' ?
                      <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                        <Form.Item label="Self Employeed Profession">
                          {getFieldDecorator('self_employed_profession', {
                            rules: [validationRules.mandatory],
                          })(
                            <Select placeholder="Select Self Employeed Profession">
                              {self_employed_profession_options && self_employed_profession_options.length && self_employed_profession_options.map(({ name = '', value = '' }) => (
                                <Option key={value} value={value}>{name}</Option>
                              ))}
                            </Select>
                          )}
                        </Form.Item>
                      </Col> : ''}
                    {getFieldValue('profession') === 'BUSINESS' ?
                      <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                        <Form.Item label="Nature of Business">
                          {getFieldDecorator('nature_of_business', {
                            rules: [validationRules.mandatory],
                          })(
                            <Select placeholder="Select Nature of Business">
                              {nature_of_business_options && nature_of_business_options.length && nature_of_business_options.map(({ name = '', value = '' }) => (
                                <Option key={value} value={value}>{name}</Option>
                              ))}
                            </Select>
                          )}
                        </Form.Item>
                      </Col> : '' }
                  </Row>
                  <Checkbox
                    checked={aadharConsent}
                    className="flex flex-start"
                    onChange={({ target: { checked } }) => this.setState({ aadharConsent: checked })}
                  >
                    {aadharConsentText}
                  </Checkbox>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-right margin-t-4">
                  <Button
                    className="width-2"
                    href={constants.LINK_PAY_BALANCE}
                  >
                    Cancel
                  </Button>
                  <Button
                    htmlType="submit"
                    className="margin-l-2 green-btn width-2"
                    disabled={!aadharConsent}
                    loading={isLoadingStatus}
                  >
                    Submit
                  </Button>
                </Col>
              </Row>
            </Form>
          </StyledYblMinKyc>
        </Col>
      </Row>);
  }

  renderModalUI(modalType) {
    switch (modalType) {
      case 'DOWNLOAD_SUCCESS':
        return (
          <Fragment>
            <Row align="top" type="flex" justify="center" gutter={10}>
              <Col xs={24} sm={24} md={22} lg={22} xl={22} className="text-center">
                <strong className="font-14">MIN KYC Completed Successfully.
                </strong>
              </Col>
            </Row>
            <Row align="middle" type="flex" justify="center" gutter={10}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className=" margin-t-2 text-center">
                <h4 className="font-14">Click here to View Your Card.
                </h4>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
                <Button
                  type="submit"
                  className="green-btn width-5 margin-t-1"
                  href={constants.LINK_PAY_BALANCE}
                >
                  Click Here
                </Button>
              </Col>
            </Row>
          </Fragment>
        );
      default:
        return <div />;
    }
  }

  render() {
    const {
      modalType,
    } = this.state;
    return (
      <div>
        <Modal
          title={null}
          show={!!modalType}
          classname="without-header"
          onClose={() => this.closeModal(modalType)}
          size="sm"
        >
          {modalType && this.renderModalUI(modalType)}
        </Modal>
        <br clear="all" />
        <Fragment>
          <Container>
            <ZaggleCard>
              <Row align="middle" type="flex" gutter={24} className="margin-t-2">
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <h1>Manage Zaggle Cards</h1>
                  <Breadcrumb separator="<" className="margin-b-2 font-12 custom-breadcrumb">
                    <Breadcrumb.Item href={constants.LINK_MY_PROFILE} className="crumb-link">My Account</Breadcrumb.Item>
                    <Breadcrumb.Item href={constants.LINK_PAY_BALANCE} className="crumb-link">Manage Cards</Breadcrumb.Item>
                    <Breadcrumb.Item>Yes Bank Min Kyc</Breadcrumb.Item>
                  </Breadcrumb>
                </Col>
              </Row>
              <Card className="rounded card-padding-20 noborder margin-b-1">
                {this.renderYblMinKycPage()}
              </Card>
            </ZaggleCard>
          </Container>
        </Fragment>
      </div>
    );
  }
}

YblMinKyc.propTypes = YblMinKycPropTypes;

const YblMinKycWrapper = Form.create({ name: 'normal_admin' })(YblMinKyc);
export default connect(YblMinKycmapStateToProps, YblMinKycmapDispatchToProps)(AppWrappperHOC(YblMinKycWrapper));
export { YblMinKyc, YblMinKycmapStateToProps, YblMinKycmapDispatchToProps, YblMinKycWrapper };



// WEBPACK FOOTER //
// client/containers/YblMinKyc/index.js